module.exports = __webpack_public_path__ + "static/media/logo.ce269cac.svg";